import type {
  VaisrRecommendParams,
  VaisrRecommendResponse,
  VaisrSearchParams,
  VaisrSearchProductsResponse,
  VaisrSuggestionResponse
} from 'src/libs/api/response/vaisrApiResponse';
import { getRequest, postRequest } from 'src/libs/wa/gateways/api/wamazingApi';

export const VAISR_API_ENDPOINT = process.env.NEXT_PUBLIC_VAISR_API_ENDPOINT || '';
const VAISR_X_API_KEY = process.env.NEXT_PUBLIC_VAISR_X_API_KEY;

const postVaisrSearchProducts = async (params: VaisrSearchParams): Promise<VaisrSearchProductsResponse> => {
  const response = await postRequest<VaisrSearchProductsResponse & { errors: string[] }>({
    baseURI: VAISR_API_ENDPOINT,
    path: '/search',
    params,
    headers: {
      'x-api-key': VAISR_X_API_KEY
    }
  });
  if (response.errors && response.errors.length > 0) {
    throw new Error(response.errors[0]);
  }
  return response;
};

const postVaisrRecommendProducts = async (params: VaisrRecommendParams): Promise<VaisrRecommendResponse> => {
  const response = await postRequest<VaisrRecommendResponse & { errors: string[] }>({
    baseURI: VAISR_API_ENDPOINT,
    path: '/predict',
    params,
    headers: {
      'x-api-key': VAISR_X_API_KEY
    }
  });
  if (response.errors && response.errors.length > 0) {
    throw new Error(response.errors[0]);
  }
  return response;
};

const fetchVaisrAutoCompletionKeywords = async (
  keyword: string,
  visitorId: string
): Promise<VaisrSuggestionResponse> => {
  const response = await getRequest<VaisrSuggestionResponse & { errors: string[] }>({
    baseURI: VAISR_API_ENDPOINT,
    path: `/suggest?q=${keyword}&suggestions=20&visitorId=${visitorId}`,
    headers: {
      'x-api-key': VAISR_X_API_KEY
    }
  });
  if (response.errors && response.errors.length > 0) {
    throw new Error(response.errors[0]);
  }
  return response;
};

export { fetchVaisrAutoCompletionKeywords, postVaisrRecommendProducts, postVaisrSearchProducts };
